import { render } from "./ApprovalFormView.vue?vue&type=template&id=35199be6&scoped=true"
import script from "./ApprovalFormView.vue?vue&type=script&lang=js"
export * from "./ApprovalFormView.vue?vue&type=script&lang=js"

import "./ApprovalFormView.vue?vue&type=style&index=0&id=35199be6&scoped=true&lang=scss"

import exportComponent from "/home/timecard-prod/OggiTimeClockSystem/electron/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35199be6"]])

export default __exports__